import { trackAmazonTagEvent, AmazonTagEvent } from './trackAmazonTagEvent';

/**
 * track an Amazon add to shopping cart event
 */
export function trackAmazonTagAddToShoppingCart(): void {
  trackAmazonTagEvent({ name: AmazonTagEvent.AddToShoppingCart });
}
